import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import Aside from '@/store/modules/App/Aside'
import Cart from '@/store/modules/App/Cart'
import Banner from '@/store/modules/App/Banner'
export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
	modules: {
		Aside,
		Cart,
		Banner
	}
}
